import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RouterModule } from '@angular/router';
import { LayoutModule } from './layout/layout.module';
import { MessageModule } from './message';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NZ_I18N, en_US, es_ES } from 'ng-zorro-antd/i18n';
import { LanguageService } from './shared/services';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BSDHttpInterceptor, ErrorInterceptor } from './core';
import { AdminLayoutModule } from './admin-layout/admin-layout.module';

import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import {
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory,
} from './core/services/auth';
import { environment } from 'src/environment/environment';
import { NgOptimizedImage, registerLocaleData } from '@angular/common';
import { PageSpinModule } from './shared/components';
import { BackToSignInModule } from './shared/components/back-to-signin/back-to-signin.module';
import { FileDownloaderComponent } from './modals/file-downloader';
import es from '@angular/common/locales/es';

registerLocaleData(es);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    LayoutModule,
    AdminLayoutModule,
    FileDownloaderComponent,
    NzNotificationModule,
    MessageModule,
    PageSpinModule,
    NgOptimizedImage,
    AppRoutingModule,
    HttpClientModule,
    BackToSignInModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.AZURE_APP_CLIENT_ID,
          authority: environment.AZURE_AUTHORITY,
          redirectUri: environment.AZURE_REDIRECT_URI,
        },
        cache: {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: true,
        },
      }),
      { interactionType: InteractionType.Redirect },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map(),
      }
    ),
  ],
  providers: [
    {
      provide: NZ_I18N,
      useFactory: (translate: LanguageService) => {
        switch (translate.language) {
          case 'en':
            en_US.Pagination.items_per_page = '';
            return en_US;
          case 'es':
            es_ES.Pagination.items_per_page = '';
            return es_ES;
          default:
            en_US.Pagination.items_per_page = '';
            return en_US;
        }
      },
      deps: [LanguageService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BSDHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
